import { Validator } from '@vista-digital/validator';
import { defaultItemModalConfig, itemModalConfigValidatorSchema } from '../../../subcomponents/item-modal/types/config';
/**
 * Default configs for the Single Item Picker component.
 */
export const defaultSingleItemPickerConfig = Object.assign(Object.assign({}, defaultItemModalConfig), { image: { show: true } });
export const singleItemPickerImageConfigValidatorSchema = Object.assign(Object.assign({}, itemModalConfigValidatorSchema), { image: Validator.object({
        show: Validator.boolean()
    }) });
export const singleItemPickerConfigValidator = Validator.object(singleItemPickerImageConfigValidatorSchema);
